import {createReducer} from '@reduxjs/toolkit';
import {getUserSettingsByEmailSuccess, saveUserSettingsSuccess} from 'src/openapi/apis/UserControllerApi';
import {UserSettings} from 'src/openapi/models/UserSettings';

type State = {
    data: UserSettings | null,
};

const defaultState = {
    data: null,
};

export const userSettings = createReducer<State>(defaultState, builder => builder
    .addCase(getUserSettingsByEmailSuccess, (state, action) => {
        state.data = {...action.payload.data};
    })
    .addCase(saveUserSettingsSuccess, (state, action) => {
        state.data = {...action.payload.meta.userSettings};
    }),
);
